import BlockAllCustomers from '@/components/blocks/Customers/BlockAllCustomers';
import BlockLeadsDashboard from '@/components/blocks/Customers/BlockLeadsDashboard';
import BlockNewCustomer from '@/components/blocks/Customers/BlockNewCustomer';
import BlockCustomerProperties from '@/components/blocks/Customers/BlockCustomerProperties';
import SuperOrAgent from '@/services/RouteGuards/SuperOrAgent';
import BlockArchivedCustomers from '@/components/blocks/Customers/BlockArchivedCustomers';
import BlockDeletedCustomers from '@/components/blocks/Customers/BlockDeletedCustomers';

export default [
	{
		path: 'customers',
		name: 'CustomersAgent',
		component: BlockAllCustomers,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Customers - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'customers/archived',
		name: 'ArchivedCustomersAgent',
		component: BlockArchivedCustomers,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Archived Customers - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'customers/deleted',
		name: 'DeletedCustomersAgent',
		component: BlockDeletedCustomers,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Deleted Customers - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'customers/leads-dashboard',
		name: 'LeadsDashboardAgent',
		component: BlockLeadsDashboard,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Leads dashboard - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'customers/new',
		name: 'NewCustomerAgent',
		component: BlockNewCustomer,
		props: {
			edit: false,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `New Customer - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'customers/single/:id',
		name: 'SingleCustomerPropertiesAgent',
		component: BlockCustomerProperties,
		props: {
			edit: false,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Single Customer - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'customers/edit/:id',
		name: 'EditCustomerAgent',
		component: BlockNewCustomer,
		props: {
			edit: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Edit Customer - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'customers/clone/:id',
		name: 'CloneCustomerAgent',
		component: BlockNewCustomer,
		props: {
			edit: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Clone Customer - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	}
];
